import { Context } from '@leverege/plugin';
import { XYChartModel } from '@leverege/ui-attributes-graphs';
import MoltenUtil from "../MoltenUtil.js";
/**
 * This will create an XYChartModel, run it through all `XYChartModelConfigurer`
 * plugins that match against the given cxt object, and return it.
 * The XYChartModelConfigurer plugins should implement a `configure( xyChartModel, objectType, cxt )`
 * function that returns a configured TableModel. 
 * @param {String|Array<String>} objectType 
 * @param {Object} cxt the match context used to find configurers
 * @returns XYXhartModel
 */
function create(objectType, cxt) {
  let xyChartModel = XYChartModel.create();
  const context = cxt || {};
  const cfgs = MoltenUtil.sortedPlugins('XYChartModelConfigurer', Context.createMatch({
    ...context,
    objectType
  }));
  cfgs.forEach(c => {
    try {
      const nXYChartModel = c.configure(xyChartModel, objectType, context);
      xyChartModel = nXYChartModel || xyChartModel;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }
  });
  return xyChartModel;
}
export default {
  create
};